module.exports = __webpack_public_path__ + "img/14.61ca3956.jpg";